import React from "react";
import { css } from "@emotion/react";
import { color, Font } from "@moneyforward/mfx_biz_react_components";
import { useIsSpMode } from "@/hooks";

type Props = {
  name: string;
  value: string;
};

export const CompanyInfoLabel = (props: Props) => {
  const isSpMode = useIsSpMode();
  return (
    <div css={!isSpMode ? container : {}}>
      <div css={labelWrapper}>
        <Font variant="m" component="p">
          {props.name}
        </Font>
      </div>
      <div css={inputWrapper}>
        <Font>{props.value ? props.value : "----------"}</Font>
      </div>
    </div>
  );
};

const container = css({
  display: "flex",
});

const labelWrapper = css({
  width: "200px",
  marginRight: "15px",
  color: color.gray600,
});

const inputWrapper = css({
  width: "100%",
});
